import { OnInit, OnDestroy, Component, Inject, Optional  } from '@angular/core';
import { IContextService, DomainContext} from '@pershing/pershing-core';
import { NxiContextUtils } from '@pershing/nxi-common';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { Subscription } from 'rxjs';

declare let dojoApp: any;

@Component({
    selector: 'dojo-college529Plan-summary',
    templateUrl: './dojo-college529Plan-summary.component.html'
})
export class DojoCollege529PlanSummaryComponent implements OnInit, OnDestroy {

    qaInternalUrl: string;
    domain: string = '';
    subs: Subscription;
    widgetparams: any;
    acctRef: string;
    isValid529Account: boolean;
    isAdaTheme: boolean = false;
    title: String;

    constructor(private paramService: NxiWidgetParamsService, private nxiRestService: NxiRestService,
                private contextService: IContextService,
                @Optional() @Inject('AppSettings') appSettings: any ) {
            this.qaInternalUrl = this.nxiRestService.serviceUrl;
            if (appSettings.themeType && appSettings.themeType === 'ada') {
                this.isAdaTheme = true;
                this.title = 'dojo-college529Plan-summary';
            }
    }

    getWidgetResponse(acctreference: string): any {
        this.paramService.getWidgetParams(acctreference, 'college529PlanSummary').subscribe(
      resp => {
        let response: any = resp.response;
        resp.response.resourceUrl = this.qaInternalUrl + resp.response.resourceUrl;
        console.log('response', response);
        this.isValid529Account = resp.response.valid529Account;
        if (dojoApp && this.isValid529Account) {
            let element = document.getElementById('portlet_College529PlanSummary_WAR_netxinvestorportfolio');
            element.classList.remove('dijitDisplayNone');
            dojoApp.renderCollege529PlanSummary();
        }  else if (dojoApp) {
            let element = document.getElementById('portlet_College529PlanSummary_WAR_netxinvestorportfolio');
            element.classList.add('dijitDisplayNone');
            dojoApp.destroyCollege529PlanSummary();
        }
      },
     error => {
         console.log('error', error);
         return error;
      }
    );
  }

    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.acctRef = contextValue.hashValue;
            this.widgetparams = this.getWidgetResponse(this.acctRef) ;
        });
    }

    ngOnDestroy(): void {
        console.log('In DojoMixinComponent destroy method');
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.destroyCollege529PlanSummary();
        }
    }
}
